import type { Banner, BannerDto } from './banner';
import { splitBanners } from './banner';
import { productImageSrc } from './image';

export type Product = {
  subcode: string;
  name: string;
  brand: string;
  image: string;
  imageProxy: string | null;
};

export type ExchangeResult =
  | { status: 'ok'; products: Product[]; topBanners: Banner[]; bottomBanners: Banner[] }
  | { status: 'changed'; seqnumber: string }
  | { status: 'expired'; message: string }
  | { status: 'error'; message: string; show: boolean }
  | { status: 'unsupported'; message: string };

type ProductDto = { code: string; name: string; brandName: string; imageUrl: string };

type ExchangeStatusDto = {
  status: 'EXCHANGEABLE' | 'USED' | 'CHANGED' | 'CANCELED' | 'EXPIRED' | null | undefined;
  products?: ProductDto[] | null;
  changedToken?: string | null;
  banners?: BannerDto[] | null;
};

function toProducts(dtos: ProductDto[], token: string | null): Product[] {
  return dtos.map((p) => ({
    subcode: p.code,
    name: p.name,
    brand: p.brandName,
    image: p.imageUrl,
    imageProxy: productImageSrc(token, p.code),
  }));
}

export function toExchangeResult(dto: ExchangeStatusDto, token: string | null = null): ExchangeResult {
  switch (dto.status) {
    case 'EXCHANGEABLE': {
      const { topBanners, bottomBanners } = splitBanners(dto.banners ?? []);
      return { status: 'ok', products: toProducts(dto.products ?? [], token), topBanners, bottomBanners };
    }
    case 'CHANGED':
      return dto.changedToken
        ? { status: 'changed', seqnumber: dto.changedToken }
        : { status: 'error', message: '이미 교환된 쿠폰입니다.', show: true };
    case 'USED':
      return { status: 'error', message: '이미 사용된 쿠폰입니다.', show: true };
    case 'CANCELED':
      return { status: 'error', message: '이미 취소된 쿠폰입니다.', show: true };
    case 'EXPIRED':
      return { status: 'expired', message: '페이지 접근 가능 기한이 만료되었습니다.' };
    case null:
    case undefined:
      return { status: 'unsupported', message: '지원하지 않는 링크예요.' };
    default:
      throw new Error(`알 수 없는 쿠폰 상태: ${String(dto.status)}`);
  }
}
